document.addEventListener(
	"keyup",
	function enableFocusOutlineOnce(e) {
		if (e.which === 9) {
			/* tab */ document.removeEventListener(
				"keyup",
				enableFocusOutlineOnce,
			);
			document.documentElement.classList.remove("no-focus-outline");
			document.documentElement.classList.add("focus-outline");
		}
	},
	{passive: true},
);
document.documentElement.classList.remove("focus-outline");
document.documentElement.classList.add("no-focus-outline");
